<template>
    <v-container>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card class="mt-4">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Búsqueda Proceso</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-form lazy-validation ref="formreporte">
                    <v-row justify="center">
                        <v-col cols="12" md="7">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <span style="font-weight: bold;">Id Proceso:</span>
                                    <v-text-field v-model="busqueda.ntclave" outlined width="20px" dense
                                        @keypress="validarRegex($event, 'N')" @paste="onPaste"
                                        @keyup.enter="Buscar()"></v-text-field>
                                    <span style="font-weight: bold;">Usuario:</span>
                                    <v-text-field v-model="busqueda.uslogin" outlined width="20px" dense
                                        @keyup.enter="Buscar()"></v-text-field>
                                    <span style="font-weight: bold;">Sitio:</span>
                                    <multiselect v-model="busqueda.ntsitio"
                                        deselect-label="No se puede remover el valor seleccionado"
                                        selected-label="Seleccionado" select-label="Seleccione un estado de cita"
                                        track-by="ntsitio" label="ntsitio" placeholder="Seleccione un sitio"
                                        :options="Sitio.CatalogoSitios" :allow-empty="false">
                                    </multiselect>

                                </v-col>
                                <v-col cols="12" md="6">
                                    <span style="font-weight: bold;">Nombre Proceso:</span>
                                    <v-text-field v-model="busqueda.ntproceso" outlined width="20px" dense
                                        @keyup.enter="Buscar()"></v-text-field>
                                    <span style="font-weight: bold;">Correo Electrónico:</span>
                                    <v-text-field v-model="busqueda.dnemail" outlined width="20px" dense
                                        @keyup.enter="Buscar()"></v-text-field>
                                    <span style="font-weight: bold;">Módulo:</span>
                                    <multiselect v-model="busqueda.ntmodulo"
                                        deselect-label="No se puede remover el valor seleccionado"
                                        selected-label="Seleccionado" select-label="Seleccione un estado de cita"
                                        track-by="ntmodulo" label="ntmodulo" placeholder="Seleccione un modulo"
                                        :options="Modulos.CatalogoModulos" :allow-empty="false">
                                    </multiselect>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <div mt-2>
                    <v-btn class="mr-4" color="#536DFE" style="color:white" @click="Buscar()">Buscar</v-btn>
                    <v-btn class="mr-4" color="default" @click="limpiar()">Limpiar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
        <v-card v-if="show" class="mt-2">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Resultados</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" v-if="!buscarxUC">
                        <DataTable :url="url" :columns="columnasNotificacion" :params="displayInputs"
                            @apiDT="apiDT = $event" :order="[]" :formatterActions="formatterActions">
                        </DataTable>
                    </v-col>
                    <v-col cols="12" v-else>
                        <DataTable :url="url" :columns="columnasUsrCorreo" :params="displayInputs"
                            @apiDT="apiDT = $event" :order="[]" :formatterActions="formatterActions">
                        </DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
        DataTable,
    },
    data: function () {

        return {
            busqueda: {
                ntclave: null,
                uslogin: null,
                ntsitio: null,
                ntproceso: null,
                dnemail: null,
                ntmodulo: null,
            },
            Sitio: {
                CatalogoSitios: [],
                ntsitio: '',
            },
            Modulos: {
                CatalogoModulos: [],
                ntmodulo: '',
            },
            url: "Sistemas/ObtenerBusquedaProceso",
            displayInputs: {
                ntclave: null,
                uslogin: null,
                ntsitio: null,
                ntproceso: null,
                dnemail: null,
                ntmodulo: null,
            },
            columnasNotificacion: [
                { name: 'Id', data: 'ntclave', title: "Id", },
                { name: 'Nombre', data: 'ntproceso', title: "Nombre" },
                { name: 'Módulo', data: 'ntmodulo', title: "Módulo" },
                { name: 'Estatus', data: 'esdesc', title: "Estatus", formatter: [this, "estatusStyle"], },
                { name: 'detalle', data: 'ntclave', title: "", formatter: [this, "Ver_Detalle"], orderable: false },
            ],
            columnasUsrCorreo: [
                { name: 'Id', data: 'ntclave', title: "Id", },
                { name: 'Nombre', data: 'ntproceso', title: "Nombre" },
                { name: 'Usuario', data: 'dnuslogin', title: "Usuario" },
                { name: 'Correo', data: 'dnemail', title: "Correo" },
                { name: 'Estatus', data: 'esdesc', title: "Estatus", formatter: [this, "estatusStyle"], },
                { name: 'detalle', data: 'ntclave', title: "", formatter: [this, "Ver_Detalle"], orderable: false },
            ],
            apiDT: null,
            show: false,
            val: 0,
            formatterActions: [
                { click: [this, "IrDetalle"] },
            ],
            buscarxUC: false,
            permisoSistemas: false,
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 60)//Permiso para Sistemas
                        this.permisoSistemas = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        await Sistemas.ObtenerCatalogo(this, 'sitio');
        await Sistemas.ObtenerCatalogo(this, 'modulo')
    },
    methods: {
        estatusStyle(datos) {
            if (datos.esdesc == 'Vigente') {
                return datos.ntclave ? `<div style="color: #3CD4A0"><i aria-hidden="true" class="v-icon notranslate mdi mdi-check-circle-outline theme--dark" style="color:#3CD4A0"></i>${datos.esdesc}</div>` : ``;
            } else {
                return datos.ntclave ? `<div style="color: #FF5C93"><i aria-hidden="true" class="v-icon notranslate mdi mdi-close-circle-outline theme--dark" style="color:#FF5C93"></i>${datos.esdesc}</div>` : ``;
            }
        },
        Ver_Detalle(datos) {
            return datos.ntclave ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.ntclave}" title="Ver detalle" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-eye theme--dark"></i></span></button></div>` : ``;
        },
        Eliminar(datos) {
            return datos.ntclave ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small secondary dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.docid}" title="Eliminar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-delete theme--dark"></i></span></button></div>` : ``;
        },
        limpiar() {
            this.busqueda.ntclave = null;
            this.busqueda.uslogin = null;
            this.busqueda.ntsitio = null;
            this.busqueda.ntproceso = null;
            this.busqueda.dnemail = null;
            this.busqueda.ntmodulo = null;
            this.show = false;
            this.buscarxUC = false;
        },
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        onPaste(event) {
            const clipboardData = event.clipboardData || window.clipboardData;
            const pastedData = clipboardData.getData("text");
            if (isNaN(pastedData)) {
                event.preventDefault();
            }
        },
        async validacion() {
            this.val = 0;
            if (this.busqueda.ntclave == null && this.busqueda.uslogin == null && this.busqueda.ntsitio == null && this.busqueda.ntproceso == null
                && this.busqueda.dnemail == null && this.busqueda.ntmodulo == null) {
                this.val++;
            }
            this.buscarxUC = (this.busqueda.uslogin != null || this.busqueda.dnemail != null) ? true : false;
        },
        async Buscar() {
            this.show = false;
            await this.validacion();
            if (this.val == 0) {
                this.show = true;
                this.displayInputs = {
                    ntclave: this.busqueda.ntclave,
                    uslogin: this.busqueda.uslogin,
                    ntsitio: this.busqueda.ntsitio != null ? this.busqueda.ntsitio.ntsitio : null,
                    ntproceso: this.busqueda.ntproceso,
                    dnemail: this.busqueda.dnemail,
                    ntmodulo: this.busqueda.ntmodulo != null ? this.busqueda.ntmodulo.ntmodulo : null,
                }
                await this.reloadTable();
                this.busqueda.ntclave = null;
                this.busqueda.uslogin = null;
                this.busqueda.ntsitio = null;
                this.busqueda.ntproceso = null;
                this.busqueda.dnemail = null;
                this.busqueda.ntmodulo = null;
            } else {
                this.$swal({
                    position: 'center',
                    icon: 'info',
                    title: 'Campos incompletos.',
                    text: 'Debe de llenar al menos un campo',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    timer: 3500,
                }).then(() => {
                });
            }
        },
        async reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        async IrDetalle(params, datos, fila) {
            let proceso = {
                ntclave: datos.ntclave,
            };
            await MetodosGenerales.guardarEnSesionInfoReporte(proceso, 'proceso');
            this.$router.push({ name: 'DetalleProceso' }).catch(error => error);;
        },
    }
}
</script>